import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Col, FormActions, Modal, Row, Title } from 'ui';
import type { GivingCreateFormValues } from '../../components/giving-create-form';
import { GivingSummaryDetails } from '../../components/giving-summary-details';
import { PayerInformation } from '../../components/payer-information';
import { useGivingCreate } from '../../hooks';
import type { GivingCreateModalType } from '../GivingCreateModal';

type P = {
  formValues: GivingCreateFormValues;
  isLoading: boolean;
  onCancel: () => void;
  onContinue: (formValues: GivingCreateFormValues, recaptchaToken: string) => void;
  type: GivingCreateModalType;
};

const GivingCreateSummary = ({ formValues, isLoading, onCancel, onContinue, type }: P) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { payerInformation } = useGivingCreate();
  const amount = formValues.showCustomAmount ? formValues.customAmount : formValues.amount;

  const handleContinue = useCallback(async () => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- This will be always defined
    const recaptchaToken = await executeRecaptcha!('donation_create');
    onContinue(formValues, recaptchaToken);
  }, [executeRecaptcha, formValues, onContinue]);

  return (
    <>
      <Row gutter={[0, 'ms']}>
        <Col span={24}>
          <Title level={4} marginBottom>
            Details
          </Title>
        </Col>
        <Col span={24}>
          <GivingSummaryDetails amount={amount} displayName={formValues.displayName} recurring={formValues.recurring} />
        </Col>
        <Col span={24}>
          <Title level={4} marginBottom>
            Billing information
          </Title>
        </Col>
        <Col span={24}>
          <PayerInformation payer={payerInformation({ formValues })} />
        </Col>
      </Row>
      <Modal.HugContent.Footer>
        <FormActions
          right={{
            children: 'Back',
            onClick: onCancel,
          }}
          submit={{
            children: type === 'default' ? 'Continue to payment' : 'Pledge my gift',
            loading: isLoading,
            onClick: handleContinue,
          }}
        />
      </Modal.HugContent.Footer>
    </>
  );
};

export default GivingCreateSummary;
